const StickyBookCall = () => (
  <a
    href="https://calendly.com/admin-dailygrinddesign/30min"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="sticky-book-call"
    aria-label="Book a Call"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-red-600 text-white px-5 py-3 rounded-full shadow-2xl hover:bg-red-700 hover:scale-105 active:scale-95 transition-all"
  >
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    <span className="font-semibold text-sm md:text-base">Book a Call</span>
  </a>
);

export default StickyBookCall;
